import { render } from "./mobileCategorizedProductDisplay.vue?vue&type=template&id=045a9828&scoped=true"
import script from "./mobileCategorizedProductDisplay.vue?vue&type=script&lang=js"
export * from "./mobileCategorizedProductDisplay.vue?vue&type=script&lang=js"

import "./mobileCategorizedProductDisplay.vue?vue&type=style&index=0&id=045a9828&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-045a9828"]])

export default __exports__